import Moment from "moment";
import { formatLocaleNumber, parseLocaleNumber } from "./localeFormat";

export function format(formatType, value) {
  if (typeof value !== "undefined") {
    switch (formatType) {
      case "date":
        //before works
        // if (Moment(value).isAfter(Moment("01-01-0001")))
        //   return Moment(value).format("DD-MM-YYYY");
        // return "-";
        // new formater which handle 19's date
        if (Moment(value).isSame("0001-01-01T00:00:00")) {
          return "-";
        }
        return Moment(value).format("DD-MM-YYYY");
      case "dateTime":
        if (Moment(value).isAfter(Moment("01-01-0001")))
          return Moment(value).format("DD-MM-YYYY HH:mm");
        return "-";
      case "time":
        if (Moment(value).isAfter(Moment("01-01-0001")))
          return Moment(value).format("LT");
        return "-";
      case "number":
        // Locale-driven display (en => US, fr/de/nl => their EU format).
        return typeof value === "number"
          ? formatLocaleNumber(value)
          : typeof value !== "undefined"
          ? value
          : 0.0;
      default:
        return value;
    }
  } else return "-";
}

// Parse a user-entered amount string in the active locale to a canonical number.
// Kept for backward compatibility; new code should import parseLocaleNumber directly.
export function convertEuroToUS(value) {
  return parseLocaleNumber(value);
}